import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";
import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [calendar] = useParameter<number[]>("@calendar");
  const [calendarDisplay] = useParameter<number[]>("@calendar_display");
  const [baseIndex, setBaseindex] = useParameter<number>("@base_index");
  const [baseIndexDisplay, setBaseIndexDisplay] = useParameter<number>("@base_index_display");
  const [commodities] = useParameter<number[]>("@commodities");
  const [commoditiesDisplay] = useParameter<number[]>("@commodities_display");

  const [method, setMethod] = useParameter<number>("@method");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@calendar": calendar,
      "@calendar_display": calendarDisplay,
      "@base_index": baseIndex,
      "@baseIndex": baseIndex,
      "@base_index_display": baseIndexDisplay,
      "@commodities": commodities,
      "@commoditiesDisplay": commoditiesDisplay,
      "@method": method,
      "@methods": [1, 2],
    });
  }, [title, subtitle, calendarDisplay, calendar, baseIndex, baseIndexDisplay, commoditiesDisplay, commodities, method, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      setMethod((parameters["@method"].value as string[]).map(Number)[0]);
      setBaseindex((parameters["@base_index"].value as string[]).map(Number)[0]);
      setBaseIndexDisplay((parameters["@base_index_display"].value as string[]).map(Number)[0]);
    },
    [setMethod, setBaseindex, setBaseIndexDisplay]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
